var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "function-review", attrs: { flat: "" } },
    [
      _c("v-card-title", { staticClass: "pa-0" }, [
        _c("h4", [_vm._v("Function Review")])
      ]),
      _vm._v(" "),
      _c(
        "v-card-text",
        { staticClass: "pa-0" },
        [
          _c("status-display-bar", {
            attrs: { "warn-message": _vm.warningMsg }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "mb-0" }, [
            _vm._v(
              "\n      Review the functions that this asset has access to and make any desired\n      changes\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-2 functionsReviewTable" },
            [
              _c("sphere-table", {
                ref: "functionsReviewTable",
                attrs: {
                  "api-endpoint":
                    _vm.functionReviewEndpoint + "?appRoleId=" + _vm.asset._Id,
                  columns: _vm.tableColumns,
                  "update-data-items": _vm.updateFunctionsData,
                  "client-side": "",
                  "table-type": "actionable",
                  name: "functionsReview"
                },
                on: {
                  selectionchange: _vm.selectionChange,
                  mounted: _vm.functionsMounted
                },
                scopedSlots: _vm._u([
                  {
                    key: "noRecordsMsg",
                    fn: function() {
                      return [_vm._v(" There are no functions to review ")]
                    },
                    proxy: true
                  },
                  {
                    key: "newValueCellTemplate",
                    fn: function(ref) {
                      var props = ref.props
                      return [
                        _c(
                          "td",
                          { staticClass: "text-xs-center" },
                          [
                            _c(
                              "v-btn-toggle",
                              {
                                staticClass: "my-1",
                                attrs: { mandatory: "" },
                                model: {
                                  value: props.dataItem.newValue,
                                  callback: function($$v) {
                                    _vm.$set(props.dataItem, "newValue", $$v)
                                  },
                                  expression: "props.dataItem.newValue"
                                }
                              },
                              _vm._l(_vm.accessLevels, function(val, idx) {
                                return _c(
                                  "v-btn",
                                  {
                                    key: idx,
                                    staticClass: "sb_btn_solid",
                                    attrs: { value: val, flat: "", small: "" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                      },
                                      input: function($event) {
                                        _vm.$emit(
                                          "updated",
                                          "function",
                                          props.dataItem,
                                          _vm.roleFunctionsList.findIndex(
                                            function(item) {
                                              return (
                                                item._id == props.dataItem._id
                                              )
                                            }
                                          )
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(val) +
                                        "\n              "
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "actionBtns",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "text-xs-right sb-table-top-actions" },
                          _vm._l(_vm.accessLevels, function(accessLevel, idx) {
                            return _c(
                              "v-btn",
                              {
                                key: idx,
                                staticClass: "sb_btn_solid",
                                attrs: {
                                  outline: "",
                                  color: accessLevel == "Remove" ? "error" : "",
                                  disabled: _vm.selectedItems.length === 0
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.changeSelections(accessLevel)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(accessLevel) +
                                    "\n            "
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }